document.addEventListener('submit', (event) => {
  const form = event.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.hasAttribute('data-loading')) return;
  if (!form.checkValidity()) return;

  const button = form.querySelector('button[type="submit"], button:not([type])');
  if (!button) return;

  button.setAttribute('aria-busy', 'true');
  button.classList.add('is-loading');
  setTimeout(() => {
    button.disabled = true;
  }, 0);
});
